
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qrcode",
      function () {
        return require("private-next-pages/qrcode.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qrcode"])
      });
    }
  